import { push } from "connected-react-router";
import { FilterState, BenchYear_Schools, ValueLabel, LinkStuff } from "../interface/MyInterfaces";
import { loadSpendingReport } from "./SpendingReportActions";
import { handleReportDisplayIdChange_SpendingReport, authenticateUserOutsideLogin, thingsForSharedLink } from "./UserActions";
import { authHeader } from "../javascript/auth-header";

export function closeFilter(hide_error: boolean) {
    return {
        type: "CLOSE_FILTER",
        payload: !hide_error
    };
}

export function openFilter() {
    return {
        type: "OPEN_FILTER",
        payload: true
    };
}

export function loadSharedLink(link_id, p1, p2) {

    return dispatch => {
        let url = "/IRISReportsMicroservice/api/SharedLink/report_link/" + link_id + "/" + p1 + "/" + p2;
        var headers = authHeader();
        fetch(url, { method: "GET", headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(async function (json) {
                var link: LinkStuff = json;

                if (link.link_id == -1) {
                    dispatch({
                        type: "BAD_LINK",
                        payload: link
                    });
                    dispatch(push("/reports/bad_link"));
                } else {
                    var done = await authenticateUserOutsideLogin();

                    dispatch(thingsForSharedLink());
                    url = "/IRISReportsMicroservice/api/SpendingReport/bench_school_names/" + link.bench_school;

                    var headers = authHeader();
                    fetch(url, { method: "GET", headers: headers })
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (json) {
                            let myschools: Array<ValueLabel>;
                            myschools = new Array<ValueLabel>();
                            json.forEach(x => {
                                myschools.push({ value: x.display_id, label: x.university });
                            });
                            link["bench_school_names"] = myschools;
                            link["agg"] = 0;
                            dispatch({
                                type: "LOAD_LINK",
                                payload: link
                            });

                            dispatch(
                                loadSpendingReport(
                                    link.university,
                                    link.display_id,
                                    link.year_type,
                                    link.start_year,
                                    link.end_year,
                                    link.spending_type,
                                    (link.work_study == "True") ? 1 : 0,
                                    0,
                                    link.negative_payment,
                                    link.bench_year,
                                    link["bench_school_names"],
                                    link["bench_school_names"], //fix to only show agg schools later
                                    link.vintage,
                                    link.submission_time
                                )
                            );

                            dispatch(
                                handleReportDisplayIdChange_SpendingReport({
                                    value: link.display_id
                                })
                            );
                        });
                }
            });
    };
}

async function getDates(display_id, vintage) {
    var results;
    let URLdates = "/IRISReportsMicroservice/api/Filter/dates/" + display_id + "/" + vintage;
    var headers = authHeader();
    await fetch(URLdates, { method: "GET", headers: headers })
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
            results = json;
        });
    return results;
};

async function getYears(display_id, vintage) {
    var results;
    let URLyears = "/IRISReportsMicroservice/api/Filter/years/" + display_id + "/" + vintage;
    var headers = authHeader();
    await fetch(URLyears, { method: "GET", headers: headers })
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
            results = json;
        });
    return results;
};

async function getBench(display_id, vintage) {
    var results;
    let URLbench = "/IRISReportsMicroservice/api/Filter/benchschools/" + display_id + "/" + vintage;
    var headers = authHeader();
    await fetch(URLbench, { method: "GET", headers: headers })
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
            results = json;
        });
    return results;
};

async function getFilterItems(display_id, vintage) {
    let myFilterState: FilterState = {};

    let getdates = await getDates(display_id, vintage);
    console.log(getdates)
    //myFilterState.vintage = vintage;
    myFilterState.Initial_date1 = getdates.date1;
    myFilterState.Initial_date2 = getdates.date2;
    myFilterState.Initial_work_study = getdates.work_study;
    myFilterState.Initial_year_type = getdates.year_type;
    myFilterState.Initial_start_year = getdates.start_year;
    myFilterState.Initial_n_years = getdates.n_years;
    myFilterState.Initial_the_university = getdates.university;
    myFilterState.hide_error = true;
    myFilterState.aggregate = false;
    myFilterState.work_study =
        myFilterState.Initial_work_study == " and 1=1" ? false : true;
    myFilterState.negative = false;

	let getyears = await getYears(display_id, vintage);

    let getbench = await getBench(display_id, vintage);

	let temp_years: Array<number> = new Array<number>();
		for (let i: number = 0; i < getyears.length; i++) {
			temp_years.push(getyears[i].the_exact_date);
		}
		// Use current year for ASU (display_id 81130) due to employee/spending data availability mismatch.  This could change in future reports
    if (+display_id === 81130) {
        if (myFilterState.Initial_date2 === undefined || parseInt(String(myFilterState.Initial_date2), 10) < myFilterState["bench_year"]) {
            myFilterState.Initial_date2 = String(myFilterState["bench_year"]);
			}
            const cyStr: any = String(myFilterState["bench_year"]) as any;
			if ((temp_years as any).indexOf(cyStr) === -1) {
				(temp_years as any).push(cyStr);
			}
		}

    let temp_byears: Array<BenchYear_Schools> = new Array<BenchYear_Schools>();
    for (let i = 0; i < getbench.length; i++) {
        const id_arr = getbench[i].the_schools.split(",");
        const name_arr = getbench[i].the_schools_names.split(",");
        let myschools = [];
        for (let j = 0; j < id_arr.length; j++) {
            if(name_arr[j].indexOf("A&amp")!=-1) {
                name_arr[j]=name_arr[j].replace("amp;","");
            }
            myschools.push({ value: parseInt(id_arr[j]), label: name_arr[j] });
        }
        temp_byears.push({ year: getbench[i].the_year, schools: myschools });
    }
    myFilterState.Initial_exact_years = temp_years;
    myFilterState.Initial_bench_years = temp_byears;
    if (temp_byears !== undefined && temp_byears.length > 0) {
        myFilterState.bench_year = temp_byears[temp_byears.length - 1].year;
        const bs = new Array(...temp_byears[temp_byears.length - 1].schools); //array is mutable so avoid 2 ref point to same array, one change will affect another
        let agg_s = new Array(...temp_byears[temp_byears.length - 1].schools);
        myFilterState.bench_schools = bs;
        if (myFilterState.Initial_the_university !== undefined)
            agg_s.push({ value: display_id, label: myFilterState.Initial_the_university.replace("the ", "") });
        myFilterState.agg_schools = agg_s;
    }
    //set defaults
    myFilterState["start_year"] = myFilterState["Initial_start_year"];
    myFilterState["end_year"] = +myFilterState["Initial_start_year"] + +myFilterState["Initial_n_years"] - 1;
    myFilterState["year_type"] = myFilterState["Initial_year_type"];
    myFilterState["report_type"] = "federal";

    var the_thing = myFilterState["Initial_bench_years"][myFilterState["Initial_bench_years"].length - 1];

    if (the_thing !== undefined)
        myFilterState["bench_year"] = the_thing.year;
    return myFilterState;
};

export function filterItemsLoading(display_id, vintage) {
    return async dispatch => {

        var myFilterState = await getFilterItems(display_id, vintage);
        dispatch({
            type: "FILTER_ITEMS_LOADING",
            payload: myFilterState
        });
        dispatch(openFilter());

    };
}

export function handleBenchYearChange(event) {

    return dispatch => {
        dispatch({
            type: "BENCH_YEAR_CHANGE",
            payload: event.value
        });
    };
}

export function handleBenchSchoolsChange(event) {

    var bs: ValueLabel[] = [];
    for (var i in event) {
        bs.push(event[i]);
    }
    return dispatch => {
        dispatch({
            type: "BENCH_SCHOOLS_CHANGE",
            payload: bs
        });
    };
}

export function handleAggregateChange(event) {
    return dispatch => {
        dispatch({
            type: "AGGREGATE_CHANGE",
            payload: event.target.checked
        });
    };
}
export function handleNegativeChange(event) {
    return dispatch => {
        dispatch({
            type: "NEGATIVE_CHANGE",
            payload: event.target.checked
        });
    };
}
export function handleWorkStudyChange(event) {
    return dispatch => {
        dispatch({
            type: "WORK_STUDY_CHANGE",
            payload: event.target.checked
        });
    };
}
export function handleEndYearChange(event) {
    return dispatch => {
        dispatch({
            type: "END_YEAR_CHANGE",
            payload: event.value
        });
    };
}
export function handleStartYearChange(event) {
    return dispatch => {
        dispatch({
            type: "START_YEAR_CHANGE",
            payload: event.value
        });
    };
}
export function handleInputChange(event) {
    return dispatch => {
        dispatch({
            type: "HANDLE_INPUT_CHANGE",
            payload: { name: event.target.name, value: event.target.value }
        });
    };
}

export function getAggSchools(agg_schools) {
    return dispatch => {
        dispatch({
            type: "GET_AGG_SCHOOLS",
            payload: agg_schools
        });
    };
}